import { client } from '../client';
import { CasePayload } from './createNewCase';
import { ICase } from './types/ICase';
import { UserRoleName } from '@brands/services/identity/types/UserProfile';

export const editCaseType = async (case_id: number, payload: CasePayload, userRole: string): Promise<ICase> => {
  let url: string;

  if (userRole === UserRoleName.SuperAdmin || userRole === UserRoleName.Admin || userRole === UserRoleName.OrganizationAdmin) {
    url = `/admin/cases/${case_id}/type`;
  } else if (userRole === UserRoleName.Provider) {
    url = `/provider/cases/${case_id}/type`;
  } else if (userRole === UserRoleName.CareAdvisor) {
    url = `/care_advisor/cases/${case_id}/type`;
  } else if (userRole === UserRoleName.Collector) {
    url = `/collector/cases/${case_id}/type`;
  } else {
    url = `/cases/${case_id}/type`;
  }
  const { data } = await client.patch(url, payload);

  return data;
};
